// Mapped to the DB

export const UnitType = {
    MINUTES: 1,
    STEPS: 2,
    TIMES: 3
};

Object.freeze(UnitType);